function getMessageID() {
    return crypto.randomUUID().replaceAll('-', '');
}


export {
    getMessageID
}